import React from 'react'
import { withTranslationCustom } from 'lib/i18next'
import { VEHICLE_INSPECTION_STATUS } from 'lib/utils/store/vehicle'

import EventFormModule from 'components/Events/EventForm/EventFormModules/EventFormModule'
import CompactFormRow from 'components/Forms/CompactForm/CompactFormRow/CompactFormRow'
import { Field } from 'formik'
import Select from 'components/Forms/FormElements/Select'

const EventFormInspectionResultModule = ({ label, t }) => {
    const options = [
        { value: VEHICLE_INSPECTION_STATUS.ACCEPTED, name: t('events:forms.inspectionResult.options.accepted') },
        { value: VEHICLE_INSPECTION_STATUS.REJECTED, name: t('events:forms.inspectionResult.options.rejected') },
        { value: VEHICLE_INSPECTION_STATUS.INTERRUPTED, name: t('events:forms.inspectionResult.options.interrupted') },
        { value: VEHICLE_INSPECTION_STATUS.ANNULLED, name: t('events:forms.inspectionResult.options.annulled') },
    ]

    return (
        <EventFormModule className="event-form-inspection-result-module">
            <CompactFormRow
                iconName="check-circle"
                label={label}
                trackName="inspectionResult"
            >
                <Field name="inspectionResult">
                    {(props) => (
                        <Select
                            {...props}
                            placeholder={t('events:forms.inspectionResult.placeholder')}
                            label=""
                            options={options}
                            size="s"
                        />
                    )}
                </Field>
            </CompactFormRow>
        </EventFormModule>
    )
}

export default withTranslationCustom(['events'])(EventFormInspectionResultModule)
